import { Props as SelectProps } from "react-select";
import { Option } from "@/@types/generics/Option";
import { SelectComponent } from "../SelectComponent";

type Props = SelectProps & {
	label?: string;
};

export const indicatorsEsbOptions: Option<number>[] = [
	{ value: 1, label: "B1 - Primeira Consulta Odontológica Programada" },
	{ value: 2, label: "B2 - Tratamentos Odontológicos Concluídos" },
	{ value: 3, label: "B3 - Taxa de Exodontia" },
	{ value: 4, label: "B4 - Escovação Supervisionada em Faixa Etária Escolar" },
	{ value: 5, label: "B5 - Procedimentos Odontológicos Preventivos na APS" },
	{ value: 6, label: "B6 - Tratamento Restaurador Atraumático" },
];

export function IndicatorsEsbSelect({ label, ...rest }: Props) {
	return (
		<div className="d-flex flex-column">
			<label htmlFor={rest.id} className="form-label">
				{label ?? "Indicadores:"}
			</label>

			<SelectComponent
				id={rest.id}
				placeholder="Selecione..."
				noOptionsMessage={() => "Nenhum nenhum indicador encontrado"}
				options={indicatorsEsbOptions}
				{...rest}
			/>
		</div>
	);
}
